import { X } from "lucide-react";

export default function AtlasFilterChip({ label, onClick, onRemove, removeLabel = "Remove filter" }) {
  return (
    <span className="group inline-flex max-w-[280px] items-stretch overflow-hidden rounded border border-gray-200 bg-white text-xs">
      <button
        type="button"
        onClick={onClick}
        className="flex min-w-0 flex-1 items-center text-left"
        title={label}
      >
        <span className="w-0.5 shrink-0 self-stretch bg-gray-400" aria-hidden="true" />
        <span className="truncate px-1.5 py-0.5 font-medium text-gray-700 group-hover:text-gray-900">
          {label}
        </span>
      </button>
      {onRemove && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onRemove?.();
          }}
          className="flex shrink-0 items-center border-l border-gray-100 px-1 text-gray-400 transition-colors hover:bg-gray-50 hover:text-gray-700"
          aria-label={removeLabel}
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </span>
  );
}
